// extracted by css-extract-rspack-plugin
export default {"root":"root-Ksa_yO","day":"day-aLDU2F","date":"date-nMz7u4"};